/**
 * All accepted forms (ISO codes, French names, English names) for SEPA-zone countries.
 * Source: EPC SEPA Membership List (2024).
 */
const SEPA_NAMES = new Set([
    // ISO 3166-1 alpha-2 codes — EU 27
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK",
    // ISO codes — non-EU SEPA members
    "AD",
    "CH",
    "GB",
    "GI",
    "GG",
    "IM",
    "IS",
    "JE",
    "LI",
    "MC",
    "NO",
    "SM",
    "VA",
    // ISO codes — French overseas territories
    "GP",
    "GF",
    "MQ",
    "RE",
    "YT",
    "PM",
    "BL",
    "MF",
    // French names
    "allemagne",
    "autriche",
    "belgique",
    "bulgarie",
    "chypre",
    "croatie",
    "danemark",
    "espagne",
    "estonie",
    "finlande",
    "france",
    "grèce",
    "grece",
    "hongrie",
    "irlande",
    "italie",
    "lettonie",
    "lituanie",
    "luxembourg",
    "malte",
    "pays-bas",
    "pologne",
    "portugal",
    "roumanie",
    "slovaquie",
    "slovénie",
    "slovenie",
    "suède",
    "suede",
    "tchéquie",
    "tcheque",
    "république tchèque",
    "andorre",
    "suisse",
    "royaume-uni",
    "grande-bretagne",
    "gibraltar",
    "islande",
    "liechtenstein",
    "monaco",
    "norvège",
    "norvege",
    "saint-marin",
    "vatican",
    "guadeloupe",
    "guyane",
    "martinique",
    "réunion",
    "reunion",
    "mayotte",
    // English names
    "germany",
    "austria",
    "belgium",
    "bulgaria",
    "cyprus",
    "croatia",
    "denmark",
    "spain",
    "estonia",
    "finland",
    "greece",
    "hungary",
    "ireland",
    "italy",
    "latvia",
    "lithuania",
    "malta",
    "netherlands",
    "holland",
    "poland",
    "romania",
    "slovakia",
    "slovenia",
    "sweden",
    "czech republic",
    "czechia",
    "andorra",
    "switzerland",
    "united kingdom",
    "great britain",
    "iceland",
    "norway",
    "san marino",
    "vatican city",
]);

/** Returns true if the given country name or ISO code belongs to the SEPA zone. */
export function isSepaCountry(country: string | null | undefined): boolean {
    if (!country) return false;
    const v = country.trim();
    return SEPA_NAMES.has(v.length === 2 ? v.toUpperCase() : v.toLowerCase());
}
